<template>
  <div class="p-personMemo mt30" :id="`memo-${memo.id}`">
    <a :href="memo.edit_path" class="d-b bd-darkOrange bdrs5 plr20 ptb15 bgc-white hov">
      <div class="d-f ai-c gap10">
        <p class="fz85 fw-b">作成日：{{ memo.format_created_at }}</p>
        <span class="d-b bdrs-max c-white fw-b fz85 plr10 lh100 ptb5" :class="{ 'bgc-darkOrange': memo.es_status === 'unsubmitted', 'bgc-blue': memo.es_status === 'submitted' }">{{ memo.es_status_i18n }}</span>
        <span class="d-b bdrs-max bgc-yellow c-white fw-b fz85 plr10 lh100 ptb5" v-if="memo.has_blank_es_items">未記入あり</span>
      </div>
      <p class="fz135 fw-b">{{ memo.company_name }}</p>
    </a>
    <button type="button" class="p-personMemo-removeButton bgc-black100 js-modalToggle" data-modal="deleteMemo-confirmationModal" @click="onDeleteClick"><i class="u-icon-cross c-white"></i></button>
  </div>
</template>

<script>
  export default {
    props: {
      propMemo: { type: Object, required: true },
    },
    data() {
      return {
        nowSending: false,
        memo: this.propMemo,
      }
    },
    created() {
      this.memo = this.propMemo;
    },
    methods: {
      async onSaveClick() {
        this.nowSending = true;
        this.$emit('update', {
          memoId: this.memo.id,
          text: this.memo.text,
          onFinally: () => {
            this.nowSending = false;
          },
        })
      },
      async onDeleteClick() {
        this.$emit('delete', {
          memoId: this.memo.id,
          onFinally: () => {},
        });
      },
    }
  }
</script>

<style scoped>
.rotate {
  animation: spin 3s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
